import { helpers } from '@/util/helpers';
import store from '../store/index';

function loginGuard(to, from, next) {
  if (store.getters['auth/currentUser']) {
    return next({ name: 'home' });
  }
  return next();
}

function authGuard(to, from, next) {
  if (!store.getters['auth/currentUser']) {
    return next(from.path === '/' ? '/login' : false);
  }
  return next();
}

function roleAndPermissionGuard(to, from, next) {
  if (!store.getters['auth/currentUser']) {
    return next('/login');
  }
  if (!to.meta.allowedRoles) {
    return next('/');
  }

  if (
    to.meta.allowedRoles.indexOf(store.getters['auth/currentUser'].role) > -1 ||
    helpers.$hasPermission(to.meta.requiredPermission) ||
    helpers.$isAdmin()
  ) {
    return next();
  }
  return next('/');
}

// To use this guard, specify requiredPermission in route meta.
// e.g. meta: { requiredPermission: 'can_view_clients' },
// Not used in every project though
function permissionsGuard(to, from, next) {
  if (!store.getters['auth/currentUser']) {
    return next('/login');
  }

  if (store.getters['auth/currentUser'].permissions[to.meta.requiredPermission]) {
    return next();
  }
  return next('/');
}

// To use this guard, specify allowedRoles in route meta.
// e.g. meta: { allowedRoles: ['admin', 'manager'] },
async function roleGuard(to, from, next) {
  if (!store.getters['auth/currentUser']) {
    return next('/login');
  }
  if (!to.meta.allowedRoles) {
    return next('/');
  }

  if (to.meta.allowedRoles.indexOf(store.getters['auth/currentUser'].role) > -1) {
    return next();
  }
  return next('/');
}

export { loginGuard, authGuard, permissionsGuard, roleGuard, roleAndPermissionGuard };
